import ResidentLayout from "./ResidentLayout";
import ResidentByProjectListPage from "./pages/ResidentByProjectListPage";
import ResidentByProjectDetailPage from "./pages/ResidentByProjectDetailPage";

export const residentRoutes = {
  path: "residents",
  component: ResidentLayout,
  children: [
    {
      name: "ResidentByProjectDetailPage",
      component: ResidentByProjectDetailPage,
      path: "data/:id"
    },
    {
      name: "ResidentByProjectListPage",
      component: ResidentByProjectListPage,
      path: "data"
    }
  ]
}


// WEBPACK FOOTER //
// ./src/features/residents/routes.js